var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5593_76128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79154 0.408203H1.7082C1.12487 0.408203 0.658203 0.87487 0.658203 1.4582V5.54154C0.658203 6.12487 1.12487 6.59154 1.7082 6.59154H5.79154C6.37487 6.59154 6.84154 6.12487 6.84154 5.54154V1.4582C6.7832 0.87487 6.37487 0.408203 5.79154 0.408203ZM5.96654 5.54154C5.96654 5.59987 5.9082 5.6582 5.84987 5.6582H1.76654C1.7082 5.6582 1.64987 5.59987 1.64987 5.54154V1.4582C1.64987 1.39987 1.7082 1.34154 1.76654 1.34154H5.84987C5.9082 1.34154 5.96654 1.39987 5.96654 1.4582V5.54154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 0.408203H8.7082C8.12487 0.408203 7.6582 0.87487 7.6582 1.4582V5.54154C7.6582 6.12487 8.12487 6.59154 8.7082 6.59154H12.7915C13.3749 6.59154 13.8415 6.12487 13.8415 5.54154V1.4582C13.7832 0.87487 13.3749 0.408203 12.7915 0.408203ZM12.9665 5.54154C12.9665 5.59987 12.9082 5.6582 12.8499 5.6582H8.76654C8.7082 5.6582 8.64987 5.59987 8.64987 5.54154V1.4582C8.64987 1.39987 8.7082 1.34154 8.76654 1.34154H12.8499C12.9082 1.34154 12.9665 1.39987 12.9665 1.4582V5.54154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79154 7.4082H1.7082C1.12487 7.4082 0.658203 7.87487 0.658203 8.4582V12.5415C0.658203 13.1249 1.12487 13.5915 1.7082 13.5915H5.79154C6.37487 13.5915 6.84154 13.1249 6.84154 12.5415V8.4582C6.7832 7.87487 6.37487 7.4082 5.79154 7.4082ZM5.96654 12.5415C5.96654 12.5999 5.9082 12.6582 5.84987 12.6582H1.76654C1.7082 12.6582 1.64987 12.5999 1.64987 12.5415V8.4582C1.64987 8.39987 1.7082 8.34154 1.76654 8.34154H5.84987C5.9082 8.34154 5.96654 8.39987 5.96654 8.4582V12.5415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 7.4082H8.7082C8.12487 7.4082 7.6582 7.87487 7.6582 8.4582V12.5415C7.6582 13.1249 8.12487 13.5915 8.7082 13.5915H12.7915C13.3749 13.5915 13.8415 13.1249 13.8415 12.5415V8.4582C13.7832 7.87487 13.3749 7.4082 12.7915 7.4082ZM12.9665 12.5415C12.9665 12.5999 12.9082 12.6582 12.8499 12.6582H8.76654C8.7082 12.6582 8.64987 12.5999 8.64987 12.5415V8.4582C8.64987 8.39987 8.7082 8.34154 8.76654 8.34154H12.8499C12.9082 8.34154 12.9665 8.39987 12.9665 8.4582V12.5415Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5593_76128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid);
export default __webpack_public_path__ + "static/media/icon_grid.1633cae33d4d62ab531747af0809867d.svg";
export { ForwardRef as ReactComponent };